if (!customElements.get("custom-carousel-swiper")) {
  customElements.define(
    "custom-carousel-swiper",
    class ProductSwiper extends HTMLElement {
      constructor() {
        super();

        this.handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.querySelector("product-carousel").classList.remove("hidden");
          document.addEventListener("DOMContentLoaded", this.sliders(this));
        };

        new IntersectionObserver(this.handleIntersection.bind(this), {
          rootMargin: "0px 0px 10px 0px",
        }).observe(this);
      }

      sliders() {
        "use strict";

        const slider_shop_instance_name = this.querySelector(
          "custom-carousel-swiper ul[data-slider-instance]"
        ).dataset.sliderInstance;

        console.log(slider_shop_instance_name, "slider_shop_instance_namedff");
        const element = document.querySelectorAll(
          "custom-carousel-swiper ul[data-slider-instance="+ slider_shop_instance_name +"] li"
        );
        const element_container = document.querySelector(
          "custom-carousel-swiper ul[data-slider-instance="+ slider_shop_instance_name +"]"
        );

        const size_check = this.querySelector(
          "custom-carousel-swiper product-carousel"
        ).dataset.slideLength;

        var size_check_val = eval(size_check);

        const class_list = [
          `${slider_shop_instance_name}`,
          "slideshow",
          "slider--desktop",
          "grid--peek",
        ];
    
        console.log(size_check_val);

        const breakpoint = window.matchMedia("(max-width:989px)");
        let swiper;

        var stylesheet = document.querySelectorAll(
          "link[href*='keen-slider.min.css']"
        );

        const breakpointChecker = function () {
          // if larger viewport and multi-row layout needed
       
          if ((size_check_val > 1 && size_check_val <= 4)&& (!breakpoint.matches === true)) {
            // clean up old instances and inline styles when available
            if (swiper !== undefined) swiper.destroy(true, true);
            stylesheet.disabled = true;
            element_container.classList.remove(...class_list);
            var removesliders = element;
            for (var removeslider of removesliders) {
              removeslider.classList.remove("keen-slider__slide"); 
            }
            // or/and do nothing
            return;

            // else if a small viewport and single column layout needed
          } else if ((size_check_val > 1 && size_check_val <= 4) && (breakpoint.matches === true)) {
            // fire small viewport version of swiper
            element_container.classList.add(...class_list);
            var addsliders = element;
            for (var addslider of addsliders) {
              addslider.classList.add("keen-slider__slide"); 
            }
              return enableSwiper();
          } else if (size_check_val <= 1 && breakpoint.matches === true) {  
            return;
          }
          else if (size_check_val > 4) {
            return enableSwiper();
          }
        }
        //autoplay functionality
        const autoplay = function (swiper) {
          let timeout;
          let mouseOver = false;
          function clearNextTimeout() {
            clearTimeout(timeout);
          }
          function nextTimeout() {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(() => {
              swiper.next();
            }, 5000);
          }
          swiper.on("created", () => {
            swiper.container.addEventListener("mouseover", () => {
              mouseOver = true;
              clearNextTimeout();
            });
            swiper.container.addEventListener("mouseout", () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
          });
          swiper.on("dragStarted", clearNextTimeout);
          swiper.on("animationEnded", nextTimeout);
          swiper.on("updated", nextTimeout);
        };

        //navigation functionality
        const navigation = function (swiper) {
          let wrapper, arrowLeft, arrowRight;

          function markup(remove) {
            wrapperMarkup(remove);
            arrowMarkup(remove);
          }

          function removeElement(elment) {
            elment.parentNode.removeChild(elment);
          }

          function createDiv(className) {
            var div = document.createElement("div");
            var classNames = className.split(" ");
            classNames.forEach((name) => div.classList.add(name));
            return div;
          }

          function arrowMarkup(remove) {
            if (remove) {
              removeElement(arrowLeft);
              removeElement(arrowRight);
              return;
            }
            arrowLeft = createDiv("arrows arrows--left");
            arrowLeft.addEventListener("click", () => swiper.prev());
            arrowRight = createDiv("arrow arrows--right");
            arrowRight.addEventListener("click", () => swiper.next());

            wrapper.appendChild(arrowLeft);
            wrapper.appendChild(arrowRight);
          }

          function updateClasses() {
            var slide = swiper.track.details.rel;

            slide === 0
              ? arrowLeft.classList.add("arrows--disabled")
              : arrowLeft.classList.remove("arrows--disabled");
            slide === swiper.track.details.slides.length - 1
              ? arrowRight.classList.add("arrows--disabled")
              : arrowRight.classList.remove("arrows--disabled");
          }

          function wrapperMarkup(remove) {
            if (remove) {
              var parent = wrapper.parentNode;
              while (wrapper.firstChild)
                parent.insertBefore(wrapper.firstChild, wrapper);
              removeElement(wrapper);
              return;
            }
            wrapper = createDiv("navigation-wrapper");
            swiper.container.parentNode.appendChild(wrapper);
            wrapper.appendChild(swiper.container);
          }

          swiper.on("created", () => {
            markup();
            updateClasses();
          });
          swiper.on("optionsChanged", () => {
            markup();
            updateClasses();
          });
          swiper.on("slideChanged", () => {
            updateClasses();
          });
          swiper.on("destroyed", () => {
            markup(true);
          });
        };

      
        let slider_instancename = `.${slider_shop_instance_name}`;


        const enableSwiper = function () {
          stylesheet.disabled = false;

          swiper = new KeenSlider(
            slider_instancename,
            {
              loop: true,
              widthOrHeight: 0,
              slides: { perView: 4 },
              breakpoints: {
                "(min-width: 990px)": {
                  slides: { perView: 4, spacing: 64 },
                },

                "(max-width: 1250px)": {
                  slides: { perView: 3 },
                  spacing: 0,
                },

                "(max-width: 989px)": {
                  slides: { perView: 1 },
                  spacing: 0,
                },
                "(max-width: 460px)": {
                  slides: { perView: 1 },
                  spacing: 0,
                },
              },
            },
            [autoplay, navigation]
          );
        };

     
        breakpoint.addListener(breakpointChecker);
        breakpointChecker();
      }
      
    }
  );
}
